export const blockIconsHardwareRouteNew = (
	<span className='material-symbols-outlined'>route</span>
);
